/**
 * @module chronic-condition
 * @description Servicio para gestionar condiciones crónicas vía API REST.
 */
import api from "@/services/api";

const endpoint = "/chronic-conditions";

/**
 * @description Consulta condiciones crónicas con filtros y paginación
 * @param {Object} params - Parámetros de búsqueda
 * @returns {Promise<{docs: Array, total: number}>} Resultado paginado
 */
function query(params) {
  return api.get(endpoint, { params }).then((res) => res.data);
}

/**
 * @description Obtiene una condición crónica por ID
 * @param {string} id - ID de la condición
 * @returns {Promise<Object>} Condición crónica
 */
function getById(id) {
  return api.get(`${endpoint}/${id}`).then((res) => res.data);
}

/**
 * @description Crea una nueva condición crónica
 * @param {Object} data - Datos de la condición
 * @param {string} data.code - Código
 * @param {string} data.name - Nombre
 * @param {string} data.description - Descripción
 * @returns {Promise<Object>} Condición creada
 */
function create(data) {
  return api.post(endpoint, data).then((res) => res.data);
}

/**
 * @description Actualiza una condición crónica existente
 * @param {string} id - ID de la condición
 * @param {Object} data - Campos a actualizar
 * @returns {Promise<Object>} Condición actualizada
 */
function update(id, data) {
  return api.put(`${endpoint}/${id}`, data).then((res) => res.data);
}

/**
 * @description Elimina una condición crónica
 * @param {string} id - ID de la condición
 * @returns {Promise<void>}
 */
function remove(id) {
  return api.delete(`${endpoint}/${id}`);
}

export default {
  query,
  getById,
  create,
  update,
  remove,
};
